// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__5CGJI","calendarButtons":"ClockData_calendarButtons__CZWgx"};